<template>
    <v-row class="mt-1">
        <v-col cols="12">
            <h1 class="text-brand">Pupils and Groups</h1>
            <p class="lead">Add and view pupils and allocate them to groups for easier task assignment.</p>
        </v-col>
        <v-col>
            <v-card class="h-100 d-flex flex-column justify-space-between">
                <div>
                    <h2 class="mt-0">Pupils</h2>
                    <p>See your whole class.</p>
                </div>
                <v-btn
                    variant="flat"
                    class="mt-4 order-3 align-self-start"
                    to="/teacher/view-pupils"
                    color="secondary-container"
                    >View</v-btn
                >
            </v-card>
        </v-col>
        <v-col>
            <v-card class="d-flex flex-column justify-space-between">
                <h2 class="mt-0">Groups</h2>
                <p>Organise your pupils into groups to easily assign books and tasks. View books assigned to groups.</p>
                <v-btn
                    variant="flat"
                    class="mt-4 order-3 align-self-start"
                    to="/teacher/groups"
                    color="secondary-container"
                    >View</v-btn
                >
            </v-card>
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
definePage({ meta: { area: 'pupils-and-groups' } });
</script>
